import { baseURL } from '..';
import { IProduct } from '../../shared/iProject';
import httpClient, { IPaginatedResponse, IResponse } from '../httpClient';
import { createHeaders, createRequest, paginationQuery } from '../util';
import { IGetProductPreviewResponse } from './iApiResponse';

const productProvider = () => {
    const getProductByIdAsync = async (id: number): Promise<IResponse<IProduct>> => httpClient.getAsync(createRequest(baseURL, `/Product/GetProductById?id=${id}`), createHeaders());

    const UpdateProductDtoAsync = async (payload: IProduct): Promise<IResponse<IProduct>> => httpClient.putAsync(createRequest(baseURL, '/Product/UpdateProductDto', payload), createHeaders());

    const insertProductWithImageAsync = async (payload: FormData): Promise<IResponse<IProduct>> =>
        httpClient.postAsync(createRequest(baseURL, '/Product/InsertProductWithImages', payload), createHeaders('multipart/form-data'));

    const updateProductWithImageAsync = async (payload: FormData): Promise<IResponse<IProduct>> =>
        httpClient.putAsync(createRequest(baseURL, '/Product/UpdateProductWithImages', payload), createHeaders('multipart/form-data'));

    const getPaginatedProductPreviewsAsync = async (pageNumber?: number, pageSize?: number, filter?: string): Promise<IResponse<IPaginatedResponse<IGetProductPreviewResponse>>> =>
        httpClient.getAsync(createRequest(baseURL, '/Product/GetPaginatedProductPreviews', undefined, paginationQuery(pageNumber, pageSize, filter)), createHeaders());

    return {
        updateProductWithImageAsync,
        insertProductWithImageAsync,
        getProductByIdAsync,
        getPaginatedProductPreviewsAsync,
        UpdateProductDtoAsync,
    };
};

export default productProvider();
